export default __webpack_public_path__ + "static/char-v-54-zh-Hant-d8568d4f1bad6adc4aec7c9d74129cba.mp4";